export default __webpack_public_path__ + "static/media/20s_background.51f99999.mp3";